













































import Vue from 'vue'
import { format, subMonths, startOfMonth, isAfter } from 'date-fns'
import { DatePickerInterval2ElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'DatePickerInterval2El',

  data: () => ({
    dates: [] as Array<string>,
    modal: false,
    dateFormat: 'yyyy-MM-dd'
  }),

  mounted () {
    this.dates = this.selectMonth()
  },

  watch: {
    dates () {
      const [start, end] = this.dates
      if (isAfter(new Date(start), new Date(end))) {
        this.dates = [end, start]
      }
    }
  },

  computed: {
    dateRangeText (): string {
      return this.dates.join(' ~ ')
    }
  },

  methods: {
    selectMonth (): Array<string> {
      if (!this.templateItemData.valueStart || !this.templateItemData.valueEnd) {
        return this.selectCurrentMonth()
      }
      const maxDate = this.templateItemData.valueEnd
      const start = this.templateItemData.valueStart
      return [start, maxDate]
    },
    selectCurrentMonth (): Array<string> {
      const maxDate = this.maxDate()
      const start = startOfMonth(new Date(maxDate))
      return [format(start, this.dateFormat), maxDate]
    },
    maxDate (): string {
      const [year, month, day] = this.templateItemData.allowedDayEnd.split('-').map(e => parseInt(e))
      const maxAllowedMonth = new Date(year, month, day)
      const date = subMonths(maxAllowedMonth, 1)
      return format(date, this.dateFormat)
    }
  },

  props: {
    templateItemData: {
      type: Object as () => DatePickerInterval2ElInterface,
      required: true
    }
  }
})
